import React, { useEffect, useMemo, useState } from 'react';
import CategoryApiService from '../../../api/CategoryApiService';
import { DataGridPro } from '@mui/x-data-grid-pro';
import EditMenuButton from '../../Modal/EditMenuButton';
import ConfirmDeleteDialog from '../../Modal/ConfirmDelete';
import { Box, Button, FormControl } from '@mui/material';
import ModifyCategoryModal from './ModifyCategoryModal';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from '../../Common/SnackbarProvider';

const Categories = () => {
    const snackbar = useSnackbar();
    const { t } = useTranslation();

    const [categories, setCategories] = useState([]);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState();

    const columns = useMemo(() => [
    {
        field: 'ctId',
            headerName: t('common.id'),
        flex: 0.5,
    },
    {
        field: 'ctName',
            headerName: t('categoriesPage.column.name'),
        flex: 2,
    },
    {
        field: 'ctSortSeq',
        headerName: t('fieldName.sortSequence'),
        flex: 2,
    },
    {
        field: 'recurring',
        headerName: t('categoriesPage.column.recurring'),
        renderCell: (params) => {
            return params.row.recurring ? t('common.yes') : t('common.no');
        },
    },
    {
        field: 'edit',
            headerName: t('common.edit'),
        flex: 0.5,
        filterable: false,
        sortable: false,
        renderCell: (params) => {
            return <EditMenuButton
                params={params}
                setShowDeleteDialog={setShowDeleteDialog}
                setCurrentSelectedRecord={setSelectedCategory}
                onEditFunc={() => {
                    setShowEditDialog(true);
                    setSelectedCategory(params.row)
                }}
            />;
        },
    }
    ], [t]);

    const categoryApiService = new CategoryApiService();

    async function getCategories () {
        const categories = await categoryApiService.GetCategories();
        setCategories(categories.data);
    }

    async function onDeleteClick(value) {
        if (!value) {
            setShowDeleteDialog(false);
            return;
        }

        if (selectedCategory) {
            const deletedCategory = await categoryApiService.deleteCategory(selectedCategory.ctId);
            if (deletedCategory && deletedCategory.success) {
                snackbar.warning(t('categoriesPage.toast.deleted'));
                await getCategories();
            }
        }

        setShowDeleteDialog(false);
    }

    function handleEditClose() {
        setShowEditDialog(false);
        setSelectedCategory(null);
        getCategories();
    }

    useEffect(() => {
        getCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return(
        <Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - var(--ct-header-h, 56px))' }}>
            <Box sx={{ mb: 2 }}>
                <h2>{t('categoriesPage.title')}</h2>
            </Box>
            <Box sx={{ mb: 2 }}>
                <div style={{ display: 'inline-block', justifyContent: 'space-between' }}>
                    <FormControl sx={{ m: 1, minWidth: 120, float: 'left' }}>
                        <Button size={'large'} variant="contained" onClick={() => setShowEditDialog(true) }>{t('categoriesPage.createButton')}</Button>
                    </FormControl>
                </div>
            </Box>
            <Box sx={{ flex: 1, minHeight: 0, width: '100%' }}>
                <DataGridPro
                    columns={columns}
                    rows={categories}
                    getRowId={(row) => row.ctId}
                    getRowHeight={() => 'auto'}
                />
            </Box>
            <ConfirmDeleteDialog
                onClose={onDeleteClick}
                open={showDeleteDialog}
            />
            <ModifyCategoryModal
                open={showEditDialog}
                onClose={handleEditClose}
                selectedCategory={selectedCategory}
                categoryApiService={categoryApiService}
                onCancel={handleEditClose}
            />
        </Box>
    );
}

export default Categories;
